import ObjectSchemaComposer from './ObjectSchemaComposer';

export default ObjectSchemaComposer;
